import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import CardDetails from "./card_details";
import { fetchManagmentData } from "../../redux/slicer/aboutUsSlicer";
import { useDispatch, useSelector } from "react-redux";

function BoardOfManagment() {
  const dispatch = useDispatch();
  const { data: managmentData, loading, error } = useSelector(
    (state) => state.aboutUs.managment
  );

  useEffect(() => {
    dispatch(fetchManagmentData());
  }, [dispatch]);

  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  const openEditPopup = (card) => {
    setSelectedCard(card);
    setIsOpenEdit(true);
  };

  const closeEditPopup = () => {
    setSelectedCard(null);
    setIsOpenEdit(false);
  };

  const settings = {
    dots: true,
    infinite: managmentData.length > 1, // Only loop if more than 1 card
    speed: 500,
    slidesToShow: managmentData.length >= 3 ? 3 : managmentData.length, // Show up to 3 cards or fewer if less data
    slidesToScroll: 1,
    prevArrow: (
      <div className="hidden md:block absolute top-1/2 left-0 transform -translate-y-1/2 bg-white p-2 rounded-full cursor-pointer z-10">
        <FaChevronLeft className="text-primary-color text-lg" />
      </div>
    ),
    nextArrow: (
      <div className="hidden md:block absolute top-1/2 right-0 transform -translate-y-1/2 bg-white p-2 rounded-full cursor-pointer z-10">
        <FaChevronRight className="text-primary-color text-lg" />
      </div>
    ),
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: Math.min(managmentData.length, 2), arrows: false } },
      { breakpoint: 600, settings: { slidesToShow: 1, arrows: true,dots: false } },
    ],
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="slider-container relative">
      <Slider {...settings}>
        {managmentData.map((card) => (
          <div key={card.id} className="p-4">
            <div className="rounded shadow-lg bg-white max-w-[300px] mx-auto h-96 flex flex-col">
              <img
                className="rounded-t-lg w-full h-[250px] object-cover "
                src={card.image_url}
                alt={card.name}
              />
              <div className="px-6 py-6 flex flex-col justify-between flex-1">
                <div className="font-bold text-primary-color text-left">
                  {card.name}
                </div>
                <p className="text-black font-semibold text-base text-justify">
                  {card.designation}
                </p>

                <div className="mt-auto pt-2">
                  <button
                    onClick={() => openEditPopup(card)}
                    className="flex items-center justify-center text-primary-color"
                  >
                    Read More
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      {isOpenEdit && selectedCard && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
          <div className="bg-white p-4 rounded shadow-lg">
            <button
              type="button"
              onClick={closeEditPopup}
              className="absolute text-4xl top-4 right-4 text-gray-500 hover:text-black"
            >
              ✕
            </button>
            <CardDetails card={selectedCard} onClose={closeEditPopup} />
          </div>
        </div>
      )}
    </div>
  );
}

export default BoardOfManagment;
